<script setup lang="ts">
import { ref, computed } from 'vue'
import { CaretUpIcon } from 'Common/components/elements/icons/Icons'

const isOpen = ref(false)
const toggle = () => {
  isOpen.value = !isOpen.value
}
const iconClass = computed<string>(() => {
  if (isOpen.value === true) return ''
  return 'rotate-180'
})
</script>

<template>
  <tr v-bind="$attrs" v-on="$attrs">
    <td class="toggle-button-container pl-1 border-t border-b border-gray-300">
      <button class="toggle-button" aria-label="Toggle Row Details" @click.stop="toggle">
        <CaretUpIcon :class="iconClass" />
      </button>
    </td>
    <slot name="main"></slot>
  </tr>
  <template v-if="isOpen">
    <slot name="details"></slot>
  </template>
</template>

<style>
.toggle-button-container {
  padding: 0 0 0 0 !important;
}

.toggle-button {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0 0 0 0.5em;
  background-color: transparent;
  border: none;
  font-size: 1em;
  cursor: pointer;
  outline: none;
}

.toggle-button:focus {
  outline: none;
}
</style>
